(function () {

    'use strict';

    var ngModule = angular.module('breakmarkApp');

	ngModule.directive('userList', function($Users, ModalService, $rootScope) {
		return {
			scope: {},
			templateUrl: 'directives/userList/table.html',
			link: function() {},
			controller: function($scope) {
				/* Paging items. */
				$scope.data = $Users.all();

                console.log($scope.data)
                /* Scope search data. */
				$scope.search = { name: ''};

				/* Function to provide the option to delete an existing product. */
				// $scope.delete = function (item) {
				// 	if (confirm('Do you want to delete this user?'))
				// 		$Users.ref.removeUser({
				// 			email: item.email
				// 		}, function(error) {
				// 			if (error) {
				// 				switch (error.code) {
				// 				  case "INVALID_USER":
				// 					console.log("The specified user account does not exist.");
				// 					break;
				// 				  case "INVALID_PASSWORD":
				// 					console.log("The specified user account password is incorrect.");
				// 					break;
				// 				  default:
				// 					console.log("Error removing user:", error);
				// 				}
				// 			} else {
				// 				console.log("User account deleted successfully!");
				// 			}
				// 		});
		    	// };

				$scope.resetPassword = function(item) {
					if (confirm('Reset the password for this user?')) {
						$Users.ref.resetPassword({
						  email: item.email
						}, function(error) {
						  if (error) {
						    switch (error.code) {
						      case "INVALID_USER":
						        console.log("The specified user account does not exist.");
						        break;
						      default:
						        console.log("Error resetting password:", error);
						    }
						  } else {
						    console.log("Password reset email sent successfully!");
						  }
						});
					}
				};

				$scope.add = function () {
		            var scope = $rootScope.$new();
		            scope.title = 'Add a New user';
		            scope.user = {};

		            var modal = ModalService.showModal({
						templateUrl: 'directives/userList/modal.html',
						scope: scope,
						controller: function($element, close) {
							scope.submit = function() {
								$Users.ref.createUser({
								  email: scope.user.email,
								  password: scope.user.password
								}, function(error, userData) {
								  if (error) {
									scope.errorMessage = '';

								    switch (error.code) {
								      case "EMAIL_TAKEN":
								        console.log("The new user account cannot be created because the email is already in use.");
										scope.errorMessage = 'Email Already taken';
										break;
								      case "INVALID_EMAIL":
								        console.log("The specified email is not a valid email.");
										scope.errorMessage = 'Invalid email address';
								        break;
								      default:
								        console.log("Error creating user:", error);
										scope.errorMessage = 'Unable to create a user';
								    }
								  } else {
									$scope.data.$add({ name: scope.user.name, email: scope.user.email, uid: userData.uid }).then(function(s) {
										$element.modal('hide');
										close(null, 1000);
									});
								  }
								});
							};
						}
					}).then(function(modal) {
		                modal.element.modal();
						modal.close.then(function(result) {});
					});
		    	};

		    	$scope.edit = function (item) {
		            var scope = $rootScope.$new();
		            scope.title = 'Edit a user';
		            scope.user = item;

		            var modal = ModalService.showModal({
		                templateUrl: 'directives/userList/modal.html',
		                scope: scope,
						controllerAs: 'ctrl',
		                controller: function($element, close) {
		                    scope.submit = function() {
		                        $scope.data.$save(scope.user);

		                        $element.modal('hide');
		                        close(null, 1000);
		                    };
		                }
		            }).then(function(modal) {
		                modal.element.modal();
		                modal.close.then(function(result) {});
		            });
		    	};
			}
		};

	});
})();
